import { array } from "prop-types";
import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { CLIENT_REGISTER, COMMON } from "../config/apiEndPoint";
import { GET, GET_V2, MULTIPART_POST, POST, PUT } from "config/api.config";

export const getClientRegisterList = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${CLIENT_REGISTER.GET_CLIENT_REGISTER_LIST}/${data?._Id}`
      : `${CLIENT_REGISTER.GET_CLIENT_REGISTER_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addClientRegister = async (data = array()) => {
  try {
    const response = await POST(CLIENT_REGISTER.UPSERT_CLIENT_REGISTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateClientRegister = async (id, data = array()) => {
  try {
    const url = `${CLIENT_REGISTER.UPSERT_CLIENT_REGISTER_DATA}/${id}`;
    const response = await PUT(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getClientRegisterDataById = async (data = array()) => {
  try {
    const url = data?.Id
      ? `${CLIENT_REGISTER.GET_CLIENT_REGISTER_LIST}/${data?.Id}`
      : `${CLIENT_REGISTER.GET_CLIENT_REGISTER_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchClientRegisterTableAndFilterSchema = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${CLIENT_REGISTER.GET_CLIENT_REGISTER_SCHEMA}/${data?._Id}`
      : `${CLIENT_REGISTER.GET_CLIENT_REGISTER_SCHEMA}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitClientRegisterFilterData = async (data = array()) => {
  try {
    const response = await POST(CLIENT_REGISTER.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitClientRegisterBill = async (id, data = array()) => {
  try {
    const url = `${CLIENT_REGISTER.ADD_CLIENT_REGISTER}/${id}/bill`;
    const response = await PUT(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitClientRegisterPermalink = async (id, data = array()) => {
  try {
    const url = `${CLIENT_REGISTER.ADD_CLIENT_REGISTER}/${id}/permalink`;
    const response = await PUT(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitClientRegisterIncentiveTarget = async (id, data = array()) => {
  try {
    const url = `${CLIENT_REGISTER.ADD_CLIENT_REGISTER}/${id}/incentive-target`;
    const response = await PUT(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getClientRegisterFetchData = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${CLIENT_REGISTER.GET_CLIENT_REGIS_LIST}/${data?._Id}`
      : `${CLIENT_REGISTER.GET_CLIENT_REGIS_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `client/Register/{clientId}` — call details Client Info tab. */
export const getClientRegisterByIdForCallDetails = async (clientId) => {
  try {
    const id = String(clientId ?? "").trim();
    if (!id) return undefined;
    const response = await GET(`${CLIENT_REGISTER.GET_CLIENT_REGIS_LIST}/${id}`);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getClientRegisterFadvDetails = async (id) => {
  try {
    const url = `${CLIENT_REGISTER.GET_CLIENT_REGIS_LIST}/${id}/fadv-details`;
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateClientRegisterAiFadvDetails = async (id, data = array()) => {
  try {
    const url = `${CLIENT_REGISTER.GET_CLIENT_REGIS_LIST}/${id}/update-AI-fadv-details`;
    const response = await PUT(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `client/Register/document-required-rows` — optional `Id` for edit. */
export const getClientRegisterDocumentRequiredRows = async (data = {}) => {
  try {
    const id = String(data?.Id ?? data?.id ?? "").trim();
    const url = id
      ? `${CLIENT_REGISTER.GET_CLIENT_REGISTER_DOCUMENT_REQUIRED_ROWS}?Id=${encodeURIComponent(id)}`
      : CLIENT_REGISTER.GET_CLIENT_REGISTER_DOCUMENT_REQUIRED_ROWS;
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `client/Register/job-require-rows` — special requirement rows, optional `Id` for edit. */
export const getClientRegisterJobRequireRows = async (data = {}) => {
  try {
    const id = String(data?.Id ?? data?.id ?? "").trim();
    const url = id
      ? `${CLIENT_REGISTER.GET_CLIENT_REGISTER_JOB_REQUIRE_ROWS}?Id=${encodeURIComponent(id)}`
      : CLIENT_REGISTER.GET_CLIENT_REGISTER_JOB_REQUIRE_ROWS;
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** Multipart upsert for add/edit client register with document uploads. */
export const upsertClientRegisterMultipart = async (formData) => {
  try {
    const response = await MULTIPART_POST(CLIENT_REGISTER.UPSERT_CLIENT_REGISTER_DATA, formData);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `common/interview-link` */
export const getCommonInterviewLinkOptions = async () => {
  try {
    const response = await GET(COMMON.INTERVIEW_LINK);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `common/client-company` */
export const getCommonClientCompanyOptions = async () => {
  try {
    const response = await POST(COMMON.CLIENT_COMPANY, {checkAccess: true});
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `common/twilio-phone` */
export const getCommonTwilioPhoneOptions = async () => {
  try {
    const response = await GET(COMMON.TWILIO_PHONE);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `common/timezone` */
export const getCommonTimezoneOptions = async () => {
  try {
    const response = await GET(COMMON.TIMEZONE);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `common/personality-test-link` */
export const getCommonPersonalityTestLinkOptions = async () => {
  try {
    const response = await GET(COMMON.PERSONALITY_TEST_LINK);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

const unwrapCommonPlanList = (payload) => {
  const data = payload?.data ?? payload;
  if (Array.isArray(data)) return data;
  const inner = data?.records ?? data?.items ?? data?.data;
  return Array.isArray(inner) ? inner : [];
};

/** Maps `GET api/v2/common/plan` rows (`{ id, display, incentiveMin, incentiveMax }`) to react-select options. */
export const mapCommonPlanApiToSelectOptions = (payload) =>
  unwrapCommonPlanList(payload)
    .map((item) => {
      const value = String(item?.id ?? item?.value ?? "").trim();
      const label = String(item?.display ?? item?.label ?? value).trim();
      if (!value) return null;
      const option = { value, label };
      if (item?.incentiveMin != null && item?.incentiveMin !== "") {
        option.incentiveMin = Number(item.incentiveMin);
      }
      if (item?.incentiveMax != null && item?.incentiveMax !== "") {
        option.incentiveMax = Number(item.incentiveMax);
      }
      return option;
    })
    .filter(Boolean);

/** GET V2 `common/plan` (`api/v2/common/plan`) */
export const getCommonPlanOptions = async () => {
  try {
    const response = await GET_V2(COMMON.PLAN);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `common/job-category` */
export const getCommonJobCategoryOptions = async () => {
  try {
    const response = await GET(COMMON.JOB_CATEGORY);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `common/client-source` */
export const getCommonClientSourceOptions = async () => {
  try {
    const response = await GET(COMMON.CLIENT_SOURCE);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
